import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  counter: {
    color: '#78909C',
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  title: {
    color: '#072D83',
    fontWeight: 600,
    fontSize: 32,
    marginBottom: theme.spacing(1),
    lineHeight: 1.2,
  },
  description: {
    color: '#546E7A',
    fontSize: 16,
  },
}));
